import { connect } from "react-redux";
import { reduxForm, reset, SubmissionError } from "redux-form";

import * as actions from "../constants/actions";
import CreateContactForm from "../components/forms/CreateContactForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => { dispatch(actions.createContact({ values, resolve, reject })); })
    .then(() => {
      dispatch(actions.setContactSuccess());
      dispatch(reset("contact"));
    })
    .catch(error => {
      throw new SubmissionError({ _error: error });
    });
};

const mapStateToProps = (state) => ({
  success: state.contact.success
});

const mapDispatchToProps = (dispatch) => ({})

const connectCreateContactForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateContactForm);

export default reduxForm({
  form: "contact",
  onSubmit
})(connectCreateContactForm);



// WEBPACK FOOTER //
// ./src/containers/CreateContactForm.js